import Redirect from '@/modules-v2/redirect/views';

const RedirectPage = [
  {
    path: '/redirect',
    name: 'RedirectPage',
    component: Redirect,
    meta: {
      title: 'Redirect',
      requiresAuth: true,
    },
  },
];

export default RedirectPage;
